import React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import {Flex, Loader, Text} from "@fluentui/react-northstar";
import languageObject from "translations";
import {AppContext, IAppContextState} from "services/AppContext";

interface IConfigProps {
}

export interface IConfigState {
    url: string;
    isLoading: boolean;
}

class Configuration extends React.Component<IConfigProps, IConfigState> {
    // Define component context
    static contextType = AppContext;
    context!: IAppContextState;

    constructor(props: IConfigProps) {
        super(props);
        this.state = {
            url: "https://" + window.location.host + "/messages",
            isLoading: false,
        }
    }

    componentDidMount() {
        if (!this.context.teams.isTeamsApp) {
            window.location.replace("/messages");
            return;
        }

        microsoftTeams.settings.registerOnSaveHandler(async (saveEvent) => {
            // Retrieve images and upload default image to server
            microsoftTeams.settings.setSettings({
                entityId: "Company_Communicator_App",
                contentUrl: this.state.url,
                suggestedDisplayName: "Company Communicator Pro",
            });
            saveEvent.notifySuccess();
        });

        // When data is loaded, set state dataLoaded to true
        microsoftTeams.settings.setValidityState(true);
        this.setState({isLoading: false})
    }

    render() {
        return this.state.isLoading ?
            <Loader style={{height: "100%"}}/>
            :
            <Flex fill column className={"p-20px"} hAlign={"center"} vAlign={"center"}>
                <Text weight={"semibold"} content={languageObject.translate("MessageConfigurationSubtitle")}/>
            </Flex>
    }

}

export default Configuration
